module.exports = "<div ng-if=\"ctrl.shouldDisplayMinAdvBox\" class=\"ut-receipt-min-adv-notice-box mt-4\">\n  <div class=\"box row\">\n      <div class=\"boxTextAndImageInfo\">\n          <img class=\"icon\" src=\"http://media-cdn.grubhub.com/grubhub-assets/image/upload/v1534250711/ces_email/icon-clock.svg\">\n          <span class=\"pl-3\">\n            <strong> Minimum advanced notice </strong>\n            <br/>\n            All menu items require a {{ctrl.defaultMinAdvNotice}} minimum advanced notice.\n          </span>\n      </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/minAdvNoticeBox.html
// module id = 767
// module chunks = 0